export { default } from './ChatFooterIceBreakingTipsMobile';
